import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
const Dashboard = React.lazy(() => import("./components/Dashboard"));
const Projects = React.lazy(() => import("./components/Projects"));
const ProfileDashboard = React.lazy(() =>
  import("./components/ProfileDashboard")
);
const CompanyProfile = React.lazy(() => import("./components/CompanyProfile"));
const UserProfile = React.lazy(() => import("./components/UserProfile"));
const UserManagement = React.lazy(() => import("./components/UserManagement"));
const SignIn = React.lazy(() => import("./components/SignIn"));
const CreateProjectStepOne = React.lazy(() =>
  import("./components/CreateProjectStepOne")
);
const SignUp = React.lazy(() => import("./components/SignUp"));
const PrivateRoute = React.lazy(() => import("./utils/PrivateRoute"));
const ForgotPassword = React.lazy(() => import("./components/ForgotPassword"));
const VerifyEmail = React.lazy(() => import("./components/VerifyEmail"));
const ResendEmail = React.lazy(() => import("./components/ResendEmail"));
const ResetPassword = React.lazy(() => import("./components/ResetPassword"));
const CreateWorkspace = React.lazy(() =>
  import("./components/CreateWorkspace")
);
const CreateProjectStepTwo = React.lazy(() =>
  import("./components/CreateProjectStepTwo")
);
const Packages = React.lazy(() => import("./components/Packages"));
const Billing = React.lazy(() => import("./components/Billing"));
const Plans = React.lazy(() => import("./components/Plans"));
const CheckOut = React.lazy(() => import("./components/CheckOut"));
const Canvas3D = React.lazy(() => import("./components/canvas/Canvas3D"));
const DataUsage = React.lazy(() => import("./components/Datausage"));
const AcceptUserInvite = React.lazy(() =>
  import("./components/acceptUserInvite")
);
const RoleManagement = React.lazy(() => import("./components/RoleManagement"));
const Loading = React.lazy(() => import("./components/Loading"));
const Canvas2D = React.lazy(() => import("./components/canvas/Canvas2D"));
const RedirectComponent = React.lazy(() => import("./utils/RedirectComponent"));
const WebARProject = React.lazy(() => import("./components/WebARProject"));
const WebARViewer = React.lazy(() => import("./components/WebARViewer"));
const Assets = React.lazy(() => import("./components/Assets"));
const Markers = React.lazy(() => import("./components/Markers"));
export default function Routes() {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <Router>
          <Switch>
            <Route exact path="/">
              <SignIn />
            </Route>
            <Route exact path="/signup">
              <SignUp />
            </Route>
            <Route exact path="/forgot-password">
              <ForgotPassword />
            </Route>
            <Route exact path="/reset-password">
              <ResetPassword />
            </Route>
            <Route exact path="/verify-email/">
              <VerifyEmail />
            </Route>
            <Route exact path="/resend-email">
              <ResendEmail />
            </Route>
            <PrivateRoute exact path="/workspace" component={Dashboard} />
            <PrivateRoute
              exact
              path="/create-workspace"
              component={CreateWorkspace}
            />
            <PrivateRoute exact path="/projects" component={Projects} />
            <PrivateRoute
              exact
              path="/create-project-p1"
              component={CreateProjectStepOne}
            />
            <PrivateRoute
              exact
              path="/create-project-p2"
              component={CreateProjectStepTwo}
            />
            <PrivateRoute
              exact
              path="/profile-dashboard"
              component={ProfileDashboard}
            />
            <PrivateRoute
              exact
              path="/company-profile"
              component={CompanyProfile}
            />
            <Route
              exact
              path="/acceptUserInvitation/:email/:token/:company_id/:team_id"
              render={(routeProps) => <RedirectComponent {...routeProps} />}
            />
            <Route exact path="/UserInvitation" component={AcceptUserInvite} />
            <PrivateRoute exact path="/user-profile" component={UserProfile} />
            <PrivateRoute
              exact
              path="/user-management"
              component={UserManagement}
            />
            <PrivateRoute exact path="/packages" component={Packages} />
            <PrivateRoute exact path="/billing" component={Billing} />
            <PrivateRoute exact path="/plans" component={Plans} />
            <PrivateRoute
              exact
              path="/role-management"
              component={RoleManagement}
            />
            <PrivateRoute exact path="/checkout" component={CheckOut} />
            <PrivateRoute exact path="/data_usage" component={DataUsage} />
            <PrivateRoute exact path="/assets" component={Assets} />
            <PrivateRoute exact path="/markers" component={Markers} />
            <PrivateRoute exact path="/canvas3d" component={Canvas3D} />
            <PrivateRoute exact path="/canvas2d" component={Canvas2D} />
            <PrivateRoute exact path="/webarproject" component={WebARProject} />
            <Route exact path="/webarviewer/:id" component={WebARViewer} />
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}
